export default "__VITE_ASSET__BPx2_plQ__"